
<div
  :class="uploadInstance.getSelectCLass()"
  v-on:drop="dropFile"
  v-on:dragover="allowDrop"
  :title="uploadInstance.getSelectFileAlarmInfo()"
>
  <file-input>
    <slot></slot>
  </file-input>
</div>
